module.exports = __webpack_public_path__ + "img/icon-tracking-new.c807762d.svg";